﻿import $ from "jquery";
import { GuiDetailGeneric } from "../../GuiDetailGeneric";

    export class GuiDetailAnfallstelle extends GuiDetailGeneric {

        constructor() {
            super("Anfallstelle");
        }
        
        attachEvents(): void {
            super.attachEvents();
            $("#btnCreateAdb").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => this.clickCreateAdb(e));
        }

        clickCreateAdb(e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) {
            this.log("clickCreateAdb");
            this.doAction(e);
        }

    }
